var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{staticClass:"cookieModal",attrs:{"src":_vm.$iubenda.getPrivacyPolicyURL(),"scrolling":"yes","frameborder":"0","allowtransparency":"true"}})])}
var staticRenderFns = []

export { render, staticRenderFns }